import { api } from '@utils/ky.util';

export const fetchTickets = async (chat_id) => {
  return await api
    .get('prepare_to_printer', {
      searchParams: { chat_id },
    })
    .json();
};
